import { useEffect, useRef } from 'react';
import { getWaterMarker } from '@/common/utils';

export default function useWaterMaker(text, domRef, extraStyle = () => ({})) {
  const _extraStyle = useRef(extraStyle);

  useEffect(() => {
    if (!text || !domRef.current) return;
    const img = getWaterMarker(text);
    addWarterMarker(img);

    let observer = null;

    // 防止没有这个api
    try {
      observer = new MutationObserver((evList) => {
        for (var i = 0, len = evList.length; i < len; i++) {
          if (evList[i].attributeName === 'style') {
            addWarterMarker(img);
            break;
          }
        }
      });
      observer.observe(domRef.current, { attributes: true, childList: false, subtree: false });
    } catch (ex) {
      console.error(ex);
    }

    return () => observer && observer.disconnect();

    function addWarterMarker(img) {
      if (!img) return;
      domRef.current.style.backgroundImage = 'url(' + img + ')';
      Object.assign(domRef.current.style, _extraStyle.current());
    }
  }, [text, domRef, _extraStyle]);
}
